import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import * as R from 'ramda';
import ViewDriverDetailsByLocation from './cards-panel/ViewDriverDetailsByLocation';
import ViewLocationDetailsByDriver from './cards-panel/ViewLocationDetailsByDriver';
import ViewSummaryByLocation from './sidebar/ViewSummaryByLocation';
import ViewSummaryByDriver from './sidebar/ViewSummaryByDriver';
import CreateDriverWizard from './create-driver-wizard/CreateDriverWizard';
import ViewDriverDrawer from './ViewDriverDrawer';
import RemoveDriverDialog from './RemoveDriverDialog';
import { usePrefetch } from '../../dispatchingApi';

const DriverStatus = () => {
  const { viewBy } = useParams();

  const [createDriver, setCreateDriver] = useState(false);
  const [viewDriver, setViewDriver] = useState();
  const [removeDriver, setRemoveDriver] = useState();

  const prefetchDriverSummary = usePrefetch('viewDriverSummaryByDriver');

  const handleOpenCreate = R.compose(setCreateDriver, R.T);
  const handleCloseCreate = R.compose(setCreateDriver, R.F);

  const handleOpenView = (driver, location) => {
    setViewDriver({ driver, location });
  };
  const handleCloseView = () => {
    setViewDriver();
  };

  const handleOpenRemove = (driver, location) => {
    setRemoveDriver({ driver, location });
  };
  const handleCloseRemove = () => {
    setRemoveDriver();
  };

  const cardsPanelProps = {
    onCreate: handleOpenCreate,
    onRemove: handleOpenRemove,
    onView: handleOpenView,
  };

  // prettier-ignore
  const sidebar = viewBy === 'driver' 
    ? <ViewSummaryByDriver />
    : <ViewSummaryByLocation />

  // prettier-ignore
  const cardsPanel = viewBy === 'driver'
    ? <ViewLocationDetailsByDriver {...cardsPanelProps}/>
    : <ViewDriverDetailsByLocation {...cardsPanelProps}/>

  useEffect(() => {
    prefetchDriverSummary();
  }, [prefetchDriverSummary]);

  return (
    <>
      {sidebar}
      {cardsPanel}
      {createDriver && <CreateDriverWizard onClose={handleCloseCreate} />}
      {viewDriver && (
        <ViewDriverDrawer
          driver={viewDriver.driver}
          location={viewDriver.location}
          onClose={handleCloseView}
          onRemove={handleOpenRemove}
        />
      )}
      {removeDriver && (
        <RemoveDriverDialog
          driver={removeDriver.driver}
          location={removeDriver.location}
          onClose={handleCloseRemove}
        />
      )}
    </>
  );
};

export default DriverStatus;
